<template>
    <div class="spaceBetweenLabel_block" :class="{isBold:isBold}">
      <span v-for="(text,index) in label" :key="index">
        <span class="global_tag_require" v-if="isRequire && index==0">*</span>
        {{ text }}
      </span>
    </div>
</template>

<script>
export default {
  name: "spaceBetweenLabel",
  props: {
    label: {
      type: String,
      default:""
    },
    isBold:{
      type:Boolean,
      default:false
    },
    isRequire:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>
<style>
.spaceBetweenLabel_block{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.isBold{
  font-weight: bold;
}
</style>
